module.exports = __webpack_public_path__ + "img/OutlanderPHEV-22.223465a0.jpg";